<div class="container" style="padding: 12px;background-color: var(--background-primary);">
    <audio control loop id="audio" src="../../assets/sounds/video-call-alert.wav" autoplay="true"></audio>
    <div>
        <div style="margin-left:10px;">
            <div>{{message}}</div>
        </div>
        <div style="margin-top: 10px;margin-left: 10px;">
            <button *ngIf="!hideConfirm"
                style="width:100px;display: inline-block;margin-top:0px;background-color: #fff;color: #000000;"
                class="btn btn-apportis-primary-theme btn-block" (click)="onConfirm()">{{confirmBtnLabel}}</button>
            <button
                style="width:100px;display: inline-block;margin-top:0px;margin-left:10px;background-color: #fff;color: #000000;"
                class="btn btn-apportis-primary-theme btn-block" (click)="onClose()">{{cancelBtnLabel}}</button>
        </div>
    </div>
</div>